var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsFocusedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9766 2.5H7.50033C5.92898 2.5 5.1433 2.5 4.65515 2.98816C4.16699 3.47631 4.16699 4.26198 4.16699 5.83333V14.1667C4.16699 15.738 4.16699 16.5237 4.65515 17.0118C5.1433 17.5 5.92898 17.5 7.50033 17.5H12.5003C14.0717 17.5 14.8573 17.5 15.3455 17.0118C15.8337 16.5237 15.8337 15.738 15.8337 14.1667V7.35702C15.8337 7.0164 15.8337 6.84608 15.7702 6.69294C15.7068 6.5398 15.5864 6.41937 15.3455 6.17851L12.1551 2.98816C11.9143 2.7473 11.7939 2.62687 11.6407 2.56343C11.4876 2.5 11.3173 2.5 10.9766 2.5Z",
    stroke: "#7AC159",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.833L12.5 10.833",
    stroke: "#7AC159",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.167L10.8333 14.167",
    stroke: "#7AC159",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 2.5V5.83333C10.833 6.61901 10.833 7.01184 11.0771 7.25592C11.3212 7.5 11.714 7.5 12.4997 7.5H15.833",
    stroke: "#7AC159"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFocusedIcon);
export default __webpack_public_path__ + "static/media/newsFocusedIcon.29a56d81afab1fd5a0e6aa17da2e0f6d.svg";
export { ForwardRef as ReactComponent };